import { render, staticRenderFns } from "./FormaPagamentoComponent.vue?vue&type=template&id=0038eb21&scoped=true&"
import script from "./FormaPagamentoComponent.vue?vue&type=script&lang=js&"
export * from "./FormaPagamentoComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormaPagamentoComponent.vue?vue&type=style&index=0&id=0038eb21&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0038eb21",
  null
  
)

export default component.exports